namespace appn.views.folders.organise {

    export function init(): void {
        const $appnForm = $('#appnForm');
        appn.iframe.bindSubmitButtonsAndNavLinks($appnForm);

        // Dynamically set the selected Forms/Docs into Model.SelectedItems
        const selectedItems = (parent as any).appn.folderFilter.selectedItems;
        selectedItems.each(function(index: number) {
            $appnForm.append('<input type="hidden" name="SelectedItems[' + index + ']" value="' + selectedItems[index].id + '" />');
        });

        // Dynamically add Model.ItemType from parent
        var caller = window.parent.location.pathname;
        if (caller.containsIgnoreCase('Screens') || caller.containsIgnoreCase('Forms'))
            $appnForm.append('<input type="hidden" name="ItemType" value="Screen" />');
        else if (caller.containsIgnoreCase('DocDefinitions'))
            $appnForm.append('<input type="hidden" name="ItemType" value="Doc" />');
        else if (caller.containsIgnoreCase('TaskTemplates'))
            $appnForm.append('<input type="hidden" name="ItemType" value="TaskTemplate" />');
        else if (caller.containsIgnoreCase('DataSources'))
            $appnForm.append('<input type="hidden" name="ItemType" value="DataSource" />');
        else if (caller.containsIgnoreCase('Dataset'))
            $appnForm.append('<input type="hidden" name="ItemType" value="Dataset" />');
        else if (window.parent.location.href.containsIgnoreCase('Dashboard'))
            $appnForm.append('<input type="hidden" name="ItemType" value="Dashboard" />');
        else if (window.parent.location.href.containsIgnoreCase('Sync'))
            $appnForm.append('<input type="hidden" name="ItemType" value="Sync" />');
        else
            throw new Error('Unknown parent caller, cannot ascertain ItemType');
    }
}
